import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { StockCalendar, StockCalendarLabel, StockCalendarArrowButton } from 'components/Calendar'
import { Spacer } from 'components/Utility'
import { Card, CardInner } from 'components/Card'

type Props = {
  currentDate: Date
  currentMonth: Date
  handleCurrentDate: (date: Date) => void
  handleCurrentMonth: (date: Date) => void
}

const StockCalendarContainer: FC<Props> = (props) => {
  const { currentDate, currentMonth, handleCurrentDate, handleCurrentMonth } = props

  return (
    <Card>
      <CardInner>
        <div className={styles.calendar__monthly__header}>
          <StockCalendarArrowButton
            currentMonth={currentMonth}
            handleCurrentMonth={handleCurrentMonth}
            label={'前月'}
            type={'prev'}
          />
          <StockCalendarLabel currentMonth={currentMonth} />
          <StockCalendarArrowButton
            currentMonth={currentMonth}
            handleCurrentMonth={handleCurrentMonth}
            label={'翌月'}
            type={'next'}
          />
        </div>
        <Spacer size={16} />
        <StockCalendar currentDate={currentDate} handleCurrentDate={handleCurrentDate} />
      </CardInner>
    </Card>
  )
}

export default StockCalendarContainer
